import { CONTENT_TILES_DEFAULT_SIZE } from '@as-react/common-types';
import { getElasticSearchIndexWithEnv } from '@as-react/common-utils';
import { all, call, getContext, put, takeLatest, fork, join, select } from 'redux-saga/effects';
import contentAPI from '../../../api/content/ContentAPI';
import { contentOverviewActions } from '../../content/actions/ContentActions.creators';
import { pushRouterState } from '../../router/sagas/RouterSagas';
import { urlActions } from '../../url/actions/UrlActions.creators';
import { ContentOverviewActionTypes } from '../types/ContentActionTypes';
export const getQueryInfo = (state) => state.url;
export const getContentPath = (state) => state.content.path;
export const getContentTags = (state) => state.content.tags;
export function* findContentSaga() {
    yield takeLatest(ContentOverviewActionTypes.FIND_CONTENT, findContent);
}
export function* findContent(action) {
    try {
        const aemConfigurationContext = yield getContext('aemConfiguration');
        const contentPath = yield select(getContentPath);
        const contentTags = yield select(getContentTags);
        const { defaultRequestParams, servicesEndpoint, activeEnvironment, elasticsearchIndex } = aemConfigurationContext;
        const elasticSearchIndexWithEnv = getElasticSearchIndexWithEnv(activeEnvironment, elasticsearchIndex);
        const queryInfo = yield select(getQueryInfo);
        const pushingRouterStateTask = yield fork(pushRouterState, Object.assign(Object.assign({}, queryInfo), { searchTerm: action.payload, page: 0, size: CONTENT_TILES_DEFAULT_SIZE }));
        let tags = [];
        if (contentTags) {
            tags = tags.concat(contentTags);
        }
        if (queryInfo.category) {
            tags.push(queryInfo.category);
        }
        if (queryInfo.type) {
            tags = tags.concat(queryInfo.type);
        }
        yield join(pushingRouterStateTask);
        yield put(urlActions.setUrlParams(Object.assign(Object.assign({}, queryInfo), { searchTerm: action.payload, page: 0, size: CONTENT_TILES_DEFAULT_SIZE })));
        const content = yield call(contentAPI.getContentFromElasticSearch, defaultRequestParams, servicesEndpoint, elasticSearchIndexWithEnv, queryInfo.page, queryInfo.size, contentPath, action.payload, tags.length > 0 ? tags : null);
        yield put(contentOverviewActions.showPlaceholderTiles());
        yield put(contentOverviewActions.updaterContentAction(content));
    }
    catch (_a) { }
}
export default function* contentSaga() {
    yield all([findContentSaga()]);
}
